import PropTypes from 'prop-types';

const SectionHeader = ({ text, center = false }) => (
  <div className="relative mb-6">
    <h2
      className={`${
        center && 'header-underline-center text-center'
      } header-underline py-4 text-2xl font-semibold`}
    >
      {text}
    </h2>
  </div>
);

SectionHeader.propTypes = {
  text: PropTypes.string.isRequired,
  center: PropTypes.bool,
};

export default SectionHeader;
